// extracted by mini-css-extract-plugin
module.exports = {"description":"stars_description__ufTS9","wrapper":"stars_wrapper__2qk2Q"};